'use client'
import InputField from '@a24/form/InputField'

const CustomerDetailsForm = ({
  isAuthenticated
}: { isAuthenticated: boolean }) => {
  return (
    <>
      <div className='grid md:flex gap-6'>
        <InputField
          readOnly={isAuthenticated}
          aria-readonly={isAuthenticated}
          outerWrapperClassName='w-full label-md'
          placeholder='Jay'
          name='first_name'
          label='First Name'
          type='text'
          rules={{
            maxLength: 20,
            required: 'First name is required'
          }}
        />
        <InputField
          readOnly={isAuthenticated}
          aria-readonly={isAuthenticated}
          outerWrapperClassName='w-full label-md'
          placeholder='Doe'
          name='last_name'
          label='Last name'
          type='text'
          rules={{
            maxLength: 30,
            required: 'Last name is required'
          }}
        />
      </div>
      <div className='grid mt-6 md:flex md:mt-10 gap-6 '>
        <InputField
          readOnly={isAuthenticated}
          aria-readonly={isAuthenticated}
          outerWrapperClassName='w-full label-md'
          placeholder='j.doe@mailto.com'
          name='email'
          label='Email'
          type='email'
          rules={{
            maxLength: 40,
            required: 'Email is required',
            validate: (value) => {
              if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                return 'Please enter a valid email address'
              }
            }
          }}
        />
        <InputField
          readOnly={isAuthenticated}
          aria-readonly={isAuthenticated}
          outerWrapperClassName='w-full label-md'
          placeholder='j.doe@mailto.com'
          name='confirm_email'
          label='Confirm Email'
          type='email'
          rules={{
            maxLength: 40,
            required: 'Emails must be the same',
            validate: (value, { email }) => {
              if (value !== email) {
                return 'Emails must be the same'
              }
              return true
            }
          }}
        />
      </div>
    </>
  )
}

export default CustomerDetailsForm
